module.exports = __webpack_public_path__ + "img/pay-layout-3.2da84c18.svg";